import { render, staticRenderFns } from "./repair-create-after.vue?vue&type=template&id=63e13142"
import script from "./repair-create-after.vue?vue&type=script&lang=js"
export * from "./repair-create-after.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports